"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'file.clipboard.images_pasted': '{count} immagine/i incollata/e dagli appunti',
};
